import { META_FALLBACK_IMAGE } from '@scentregroup/shared/constants'
import { makeSchemaImageUrls } from '@scentregroup/shared/hub-components/cloudinary-image/helpers/make-image-url'
import { NewsArticle, WithContext } from 'schema-dts'
import { ContentDetail } from '../get-content-detail'
import { toDateString } from '../to-date-string'

export function getNewsArticleStructuredDataFromStory(
  story: ContentDetail['story'],
  canonicalUrl: string
): WithContext<NewsArticle> {
  const image = story.heroImageSet?.master?.url || META_FALLBACK_IMAGE
  const domain = new URL(canonicalUrl).host

  return {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    '@id': `${canonicalUrl}#newsarticle`,
    headline: story.title,
    image: makeSchemaImageUrls(image),
    datePublished: toDateString(story.sys.firstPublishedAt),
    dateModified: toDateString(story.sys.publishedAt),
    author: {
      '@type': 'Organization',
      name: 'Westfield',
      url: `https://${domain}/`,
    },
  }
}
